import React from 'react';
import { Layout } from '../../v2/components/common';
import {
  AddArchitectPackages,
  PlansAndPricing,
  PricingToMatch,
  UnlockPerProperty,
  ChooseThePlan,
  FAQ,
  GettingStarted,
} from '../../v2/components/pricing';

const Pricing = () => (
  <Layout title="Pricing" buttonType="SCHEDULE_A_DEMO">
    <PlansAndPricing />
    <AddArchitectPackages />
    <PricingToMatch />
    <UnlockPerProperty />
    <ChooseThePlan />
    <FAQ />
    <GettingStarted />
  </Layout>
);

export default Pricing;
